var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestConducted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9268 3.78125C11.9268 3.34982 12.2466 3 12.641 3H18.3553C18.7498 3 19.0696 3.34982 19.0696 3.78125V6.90625C19.0696 7.33768 18.7498 7.6875 18.3553 7.6875H12.641C12.2466 7.6875 11.9268 7.33768 11.9268 6.90625V3.78125Z",
    fill: "#D946EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07143 4.5625H10.5V8.20839C10.5 8.78371 10.9477 9.25 11.5 9.25H19.5C20.0523 9.25 20.5 8.78371 20.5 8.20839V4.5625H21.9286C23.901 4.5625 25.5 6.31143 25.5 8.46875V24.0937C25.5 26.2511 23.901 28 21.9286 28H9.07143C7.09902 28 5.5 26.2511 5.5 24.0937V8.46875C5.5 6.31143 7.09902 4.5625 9.07143 4.5625ZM15.5 13.9375C15.1055 13.9375 14.7857 14.2873 14.7857 14.7187C14.7857 15.1502 15.1055 15.5 15.5 15.5H21.2143C21.6087 15.5 21.9286 15.1502 21.9286 14.7187C21.9286 14.2873 21.6087 13.9375 21.2143 13.9375H15.5ZM14.7857 20.9687C14.7857 20.5373 15.1055 20.1875 15.5 20.1875H18.3571C18.7516 20.1875 19.0714 20.5373 19.0714 20.9687C19.0714 21.4002 18.7516 21.75 18.3571 21.75H15.5C15.1055 21.75 14.7857 21.4002 14.7857 20.9687ZM9.07143 14.7187C9.07143 13.4243 10.0308 12.375 11.2143 12.375C12.3978 12.375 13.3571 13.4243 13.3571 14.7187C13.3571 16.0132 12.3978 17.0625 11.2143 17.0625C10.0308 17.0625 9.07143 16.0132 9.07143 14.7187ZM9.07143 20.9687C9.07143 19.6743 10.0308 18.625 11.2143 18.625C12.3978 18.625 13.3571 19.6743 13.3571 20.9687C13.3571 22.2632 12.3978 23.3125 11.2143 23.3125C10.0308 23.3125 9.07143 22.2632 9.07143 20.9687Z",
    fill: "#D946EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestConducted);
export default __webpack_public_path__ + "static/media/TestConducted.75ed4918f4dad4139f20f0d49a6582c2.svg";
export { ForwardRef as ReactComponent };